export const consultationHero = {
  title: '個別相談予約',
  titleEn: 'CONSULTATION',
  lead: 'コース選びや受講のご不安は、無料の個別相談でお気軽にご相談ください。オンラインでも来校でも承ります。',
};

export const consultationFeatures = [
  {
    icon: 'ri-book-open-line',
    title: 'コース選びの相談',
    titleEn: 'Course Selection',
    description: 'エッセンシャル・アドバンス・マスターの3コースから、ご経験や目標に合った最適なコースをご提案します。',
  },
  {
    icon: 'ri-file-text-line',
    title: 'カリキュラム・料金の説明',
    titleEn: 'Curriculum & Pricing',
    description: '各コースの学習内容や一日の流れ、受講料の内訳まで、詳しくご説明します。ご不明点は何でもお尋ねください。',
  },
  {
    icon: 'ri-briefcase-line',
    title: 'キャリアの相談',
    titleEn: 'Career Guidance',
    description: '修了後のキャリアパスや、執事としての働き方について、業界の動向を踏まえてアドバイスいたします。',
  },
  {
    icon: 'ri-building-line',
    title: '見学の手配',
    titleEn: 'Campus Tour',
    description: '実際の教室や実習スタジオをご見学いただけます。施設の雰囲気を直接ご体感ください。',
  },
];

export const consultationFormOptions = {
  methods: [
    { value: 'online', label: 'オンライン（ビデオ通話）', description: 'ご自宅からご参加いただけます。使用ツールはご予約後にご案内します。' },
    { value: 'visit', label: '来校', description: '東京・お台場の教室で直接ご相談いただけます。' },
  ],
};

export const consultationFaqs = [
  {
    question: '相談は無料ですか?',
    answer: 'はい。個別相談は無料です。オンライン（ビデオ通話）でも来校でも承ります。',
  },
  {
    question: 'どんなことを相談できますか?',
    answer: 'コース選び、カリキュラムや料金の説明、キャリアのご相談、見学の手配など、何でもご相談ください。',
  },
  {
    question: '予約後の流れは?',
    answer: '送信後2営業日以内に、担当者より日時調整のご連絡を差し上げます。',
  },
];

export const consultationRelatedPages = [
  {
    title: '入学案内概要',
    description: '入学の流れと応募資格',
    href: '/admission',
  },
  {
    title: 'コース一覧・比較',
    description: '3コースの違いを一覧で確認',
    href: '/courses',
  },
  {
    title: '体験講座',
    description: '1日で執事の所作を体験',
    href: '/seminar',
  },
  {
    title: 'アクセス',
    description: '東京お台場の教室への行き方',
    href: '/access',
  },
];